<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 
    <el-main  v-loading.fullscreen.lock="loading">
      <h3>{{$t('field.docContent')}}</h3>
      <el-form ref="form" :model="form" label-width="150px" :rules="rules">        
        <el-row>             
          <el-col :span="24" style="text-align:right;padding-bottom:10px">
            <el-button type="danger" @click="docDelete"  size="small" v-if="canDelete">{{$t('button.docDelete')}}</el-button><!--作廢-->
            <el-button type="warning" @click="save"  size="small" v-if="canSave">{{$t('button.save')}}</el-button>
            <el-button type="success" @click="submit"  size="small" v-if="canSubmit">{{$t('button.submit')}}</el-button>

            <!--<el-button type="success" @click="cosign"  size="small" v-if="canCosign">{{$t('button.cosign')}}</el-button> -->
            <el-button type="success" @click="forward"  size="small" v-if="canApprove">{{$t('button.forward')}}</el-button>
            <el-button type="success" @click="approve"  size="small" v-if="canApprove">{{$t('button.approve')}}</el-button>
            <el-button type="danger" @click="reject"  size="small" v-if="canReject">{{$t('button.reject')}}</el-button>
          </el-col>
        </el-row>
        <el-row>    
          <el-col :span="8">
            <el-form-item :label="$t('field.docNo')">
              <el-input v-model="form.requestNo" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.applyDate')">
              <el-input v-model="form.applyDateStr" :disabled="true"></el-input>          
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.docStatus')" >
              <el-input v-model="form.status" :disabled="true"></el-input>    
            </el-form-item>
          </el-col>             
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('field.createAccount')" ><!-- createAccount -->
              <el-input v-model="form.createAccount" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.dept')">
              <el-input v-model="form.createDept" :disabled="true"></el-input>    
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.tel')" >
              <el-input v-model="form.createExtNo" :disabled="true"></el-input>    
            </el-form-item>
          </el-col>             
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('field.requestAccount')" prop="applyAccount"><!-- applyAccount -->
              <EmployeeSearch @sync-select-employee="syncpRequestEmp" :pSelectEmp.sync="form.applyAccount"  :pOnlyView="onlyView" :pModelName="form.applyAccount"/>   
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.dept')">
              <el-input v-model="form.applyDept" :disabled="true"></el-input>    
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.tel')" >
              <el-input v-model="form.applyExtNo" :disabled="true"></el-input>    
            </el-form-item>
          </el-col>             
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('field.crReason')" prop="reason">
              <el-radio-group v-model="form.reason">  
                <el-radio :label=reasonOpts[0] :value=reasonOpts[0] :disabled="onlyView"></el-radio>
                <el-radio :label=reasonOpts[1] :value=reasonOpts[1] :disabled="onlyView"></el-radio>
                <el-radio :label=reasonOpts[2] :value=reasonOpts[2] :disabled="onlyView"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>             
        </el-row>
        <div v-if="form.reason == reasonOpts[0]">
          <el-row>
            <el-col :span="15">
              <CustomerSearch v-model="form.custSapCode"  :pSelectValue.sync="form.custSapCode"  @sync-select-customer="syncSelectCustomer"  :pOnlyView="onlyView"/>         
            </el-col>
          </el-row>
        </div>
        <div v-if="form.reason == reasonOpts[1]" > 
          <el-row>
            <el-col :span="15">
              <FeedbackSearch  :pSelectValue.sync="form.feedbackNo" @sync-select-feedback="syncSelectFeedback" :pOnlyView="onlyView"/>           
            </el-col>
          </el-row>
        </div>
        <div v-if="form.reason == reasonOpts[2]"  >
        </div>
        <el-row>
          <el-col :span="24">
            <el-form-item  :label="$t('field.description')" >
              <el-input type="textarea" :placeholder="$t('msg.YRequiredWhenReasonX').replace('{field}',$t('field.description')).replace('{reason}',reasonOpts[2])"
                v-model="form.description" maxlength=1500  :disabled="onlyView" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row>
          <el-col :span="10">
            <el-form-item label="Target" prop="target">
               <el-select v-model="form.target" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  :disabled="onlyView" @change="targetChange" filterable allow-create>
                <el-option-group v-for="group in targetOpts" :key="group.label" :label="group.label">    
                  <el-option v-for="item in group.options" :key="item.value+'@'+group.label" :label="item.label"  :value="item.value" >
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="1" style="margin: 3px;"></el-col>
          <el-col :span="12">
            <el-input v-model="form.targetOther" maxlength=200 :placeholder="$t('field.systemNameandTypeHint')" :disabled="onlyView"></el-input>
          </el-col>   
        </el-row> 
        <el-row>
          <el-col :span="10">
            <el-form-item label="Model Name" >
              <el-select v-model="form.modelNameArr" :placeholder="$t('msg.pleaseSelect')" style="width:100%"  :disabled="onlyView" multiple filterable allow-create>
                <el-option-group v-for="group in modelNameOpts" :key="group.label" :label="group.label">    
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label"  :value="item.value">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="1" style="margin: 3px;"></el-col>
          <el-col :span="12">
            <el-input v-model="form.modelNameOther" maxlength=200 :placeholder="$t('field.systemNameandTypeHint')" :disabled="onlyView"></el-input>
          </el-col>   
        </el-row> 
        <FileEditList ref="fileList" :onlyView="fileOnlyView" :docId.sync="form.id" uploadType="cr"  @sync-save-status="syncFileSave" />
        <br>
        <el-row>
          <el-col :span="8">
            <el-form-item label="PM"  prop="pm">
              <EmployeeSearch @sync-select-employee="syncPm" :pSelectEmp.sync="form.pm" :pOnlyView="onlyView" prop="selectEmp"/>
            </el-form-item>
          </el-col>   
          <el-col :span="16"> 
            <el-form-item :label="$t('field.endorser')"  > 
              <EmployeeMultiSearch ref="endorsers" @sync-select-employee="syncEndorser" :pselectValue.sync="form.endorser" :pOnlyView="onlyView" />
            </el-form-item>
          </el-col>          
        </el-row>
        <div class="ecrStyle" v-if="showEcrEcn">
          <br>
          <el-row>
            <el-col :span="9">
              <el-form-item label="ECR No.">
                <el-input v-model="form.ecrNo" :disabled="disabledEcrEcn" maxlength=200></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="ECN No.">
                <el-input v-model="form.ecnNo" :disabled="disabledEcrEcn" maxlength=200></el-input>    
              </el-form-item>
            </el-col>   
            <el-col :span="4" style="text-align:right;" v-if="!disabledEcrEcn"> 
              <el-button type="warning" @click="saveEcr"  size="small">{{$t('button.save')}}</el-button>
              <el-button type="warning" @click="createCnc"  size="small">{{$t('button.createCnc')}}</el-button>
            </el-col>   
          </el-row>
        </div>
      </el-form>
      <h3>{{$t('field.signHistory')}}</h3>
      <div style="width:100%">
        <el-table ref="historyTable" :data="historyTable.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')" >
          <el-table-column v-for="(v, i) in historyTable.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
            <template slot-scope="scope">          
              <span>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog ref="signDialog" :title="$t('field.signDialogTitle')" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
        <el-form :model="signForm"  label-width="100px">
          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('field.signAction')" >
                <el-input v-model="signForm.signAction" :disabled="true" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="signForm.signAction=='Forward'">
            <el-col :span="24">
              <el-form-item :label="$t('field.forwardPerson')"><!-- forwardEmp -->
                <EmployeeSearch @sync-select-employee="syncForwardEmp"  />   
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('field.signComment')" >
                <el-input v-model="signForm.signComment" type="textarea" maxlength="4000" show-word-limit rows="3"></el-input>
              </el-form-item>
            </el-col>        
          </el-row>         
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{$t('button.cancel')}}</el-button>
          <el-button type="warning" @click="sendApprove">{{$t('button.submit')}}</el-button>
        </span>
      </el-dialog>

    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue'
import FileEditList from "../components/FileEditList";
import EmployeeSearch from '../components/EmployeeSearch'
import EmployeeMultiSearch  from '../components/EmployeeMultiSearch'
import CustomerSearch from "../components/CustomerSearch";
import FeedbackSearch from "../components/FeedbackSearch";
import CommonUtil from "../../utils/commonUtil.js";
import { apiFindEmpByAdAccount, apiFindEmpByEmpNo, apiFindTargetList, apiFindModelNameList, apiSaveCrDoc, apiSendApproveCRDoc, apiFindCrDocById, 
         apiFindProcessLogListByDocId, apiHasEcrecnAuth, apiSaveEcrecn, apiCreateCNC } from "../../utils/api.js";
import authHeader from "../../services/auth-header";

export default {
  name: 'createCR',
  data() {    
    return {     
      loading:false,
      onlyView:true,
      fileOnlyView:true,
      showEcrEcn:false,
      disabledEcrEcn:true,
      saveSuccess:false,
      dialogVisible:false,
      targetOriData:[],
      form:{
        id:'',      
        requestNo:'',     
        applyDate:'',    
        applyDateStr:'',    
        applyAccount:'',//申請人
        applyDept:'',     
        applyExtNo:'',    
        createAccount:'', //填表人 save時要set value
        createDept:'',    
        createExtNo:'',   
        reason:'',        
        custSapCode:'',   
        feedbackNo:'',
        description:'',   
        target:'', 
        targetType:'',       
        targetOther:'',   
        modelName:'',    
        modelNameArr:[],
        modelNameOther:'',
        pm:'',  //save時要set value 
        endorser:'',        
        ecrNo:'',         
        ecnNo:'',   
        status:'' 
      },
      rules: { 
        applyAccount: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' } ],
        reason: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        //modelNameArr: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        target: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        pm: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' }],
      }, 
      signForm:{
        signAction:'',
        signComment:'',
        forwardEmp:''
      },
      reasonOpts:['Customer requests', 'Customer complaints', 'New'],
      targetOpts:[],
      modelNameOpts:[],
      pRequestEmp:'',
      canSave:false, 
      canSubmit:false,
      canDelete:false,
      canForward:false,
      canApprove:false,
      canReject:false,
      historyTable:{
        columns: [ 
          { field: "taskName", title: this.$i18n.t('field.taskName'), width: 150 },         
          { field: "assignee", title: this.$i18n.t('field.taskOwner') , width: 180  },
          { field: "startTime", title:this.$i18n.t('field.taskReceived'), width: 150 },
          { field: "endTime", title: this.$i18n.t('field.taskSigned'), width: 150  },
          { field: "status", title: this.$i18n.t('field.signAction'), width: 150 },
          { field: "approveComment", title: this.$i18n.t('field.signComment') }
        ],
        data: []
      },
      targetType:['document(有分Model)','document(不分Model)','document(Other)','document(INCX Education Training)','software','Firmware','Updated package','Other']
    };
  },     
  components: {
    Breadcrumb,
    FileEditList,
    EmployeeSearch,
    EmployeeMultiSearch,
    CustomerSearch,
    FeedbackSearch
  },
  created(){ 
    this.form.id = this.$route.params.id;
    if(this.form.id == null){
      console.log("create"); 
      this.form.applyDateStr = CommonUtil.dateFormat(new Date());
      this.form.status = 'Draft';
      let loginUser = this.$store.state.auth.user.username;     
      this.canSave = true; 
      this.canDelete = true;
      this.canSubmit = true;
      this.onlyView = false; 
      apiFindEmpByAdAccount({ headers: authHeader(), condition: loginUser}).then((response) => {        
  
        if(response.status== 200 && response.data != null && response.data != ''){    
          this.form.createAccount = response.data.name+'('+response.data.empNo+')';
          this.form.createDept = response.data.dept;
          this.form.createExtNo = response.data.ext;
        }
      }).catch((err) => {  console.log(err);  });

    }else {
      console.log("modify:"+this.form.id );
    }
    
  },
  mounted() {
    //初始狀態 apiFindTargetList, apiFindModelNameList,
    apiFindTargetList({ headers: authHeader()}).then((response) => {         
      if(response.status== 200 && response.data != null && response.data != ''){
        this.targetOriData = response.data;
        
        CommonUtil.setGroupSelectItem(response.data, this.targetOpts)    
      }
    }).catch((err) => {  console.log(err);  });
      
    apiFindModelNameList({ headers: authHeader()}).then((response) => {         
      if(response.status== 200 && response.data != null && response.data != ''){    
        CommonUtil.setGroupSelectItem(response.data, this.modelNameOpts)
      }
    }).catch((err) => {  console.log(err);  });
    if(this.form.id != null && this.form.id != ''){      
      apiFindCrDocById({ headers: authHeader(), condition:this.form.id}).then((response) => {         
        this.setFormValue(response.data); 
        this.form.modelNameArr = [];
        if(this.form.modelName != null && this.form.modelName != ''){
          let tempArr = this.form.modelName.split(';');
          tempArr.forEach((item, index) => {  
            if(item != null && item != ''){
              this.form.modelNameArr.push(item)
            }  
          })
        }        
        
        apiFindProcessLogListByDocId({ headers: authHeader(), condition:this.form.id, condition1:'CR'}).then((response) => { 
          let auth = response.data.auth;
          if(response.data.historyList.length > 0){
            this.historyTable.data = response.data.historyList;
          }
          
          this.signAuth(auth);
        }).catch((err) => {
          console.log(err);
        });

        if(this.form.status == 'Closed'){
          //如果該單已結案並且尚未開立cnc單, 可無限次修改ECR, ECN單號
          this.showEcrEcn=true
        }
      }).catch((err) => {
        console.log(err);
      });  
    }
  },
  watch:{
    "form.applyAccount": function(){
      if(this.form.applyAccount == null || this.applyAccount == ''){
        this.form.createDept = '';
        this.form.createExtNo = '';
      }else{
        this.validateApplyAccount();
      }
    },
    "form.reason":function(){
      this.feedbackNo = '';
      this.custSapCode = '';
    },
    "form.pm": function(){
      this.validatePm()
    },
    '$route':function(){
      if(this.$route.fullPath == '/createCR'){
        location.reload()
      }
    }
  },
  methods: {
    setFormValue(data){
      this.form.id = data.id;   
      this.form.requestNo = data.requestNo;    
      this.form.applyDate = data.applyDate;   
      this.form.applyDateStr = data.applyDateStr;   
      this.form.applyAccount= data.applyAccount;  
      this.form.applyDept = data.applyDept;    
      this.form.applyExtNo = data.applyExtNo;   
      this.form.createAccount = data.createAccount;
      this.form.createDept = data.createDept;   
      this.form.createExtNo = data.createExtNo;  
      this.form.reason = data.reason;       
      this.form.custSapCode = data.custSapCode;  
      this.form.feedbackNo= data.feedbackNo;  
      this.form.description = data.description;  
      this.form.target = data.target;       
      this.form.targetOther = data.targetOther;  
      this.form.modelName = data.modelName;     
      this.form.modelNameOther= data.modelNameOther;  
      this.form.pm = data.pm; 
      this.form.endorser = data.endorser;       
      this.form.ecrNo = data.ecrNo;        
      this.form.ecnNo = data.ecnNo;  
      this.form.status= data.status;  
    },
    signAuth(auth){      
      this.canSave = false; 
      this.canSubmit = false;
      this.canDelete = false;
      this.canForward = false;
      this.canApprove = false;
      this.canReject = false;
      this.onlyView = true;
      let lastHistory = this.historyTable.data.filter(function(item) {  
        return (item.endTime == null || item.endTime == ''  )
      }); 
   
      if(auth){
        let step = '';
        if(lastHistory.length > 0){
          step = lastHistory[0].taskName;
        }
        if(this.form.status == 'Draft' || step == 'Written by'){
          this.canSave = true; 
          this.canDelete = true;
          this.canSubmit = true;
          this.onlyView = false;
        } else {          
          if(step == 'Applicant'){
            this.canSave = true; 
            this.canDelete = true;
            this.canApprove = true;
            this.canReject = true;
            this.onlyView = false;
          }else if(step == 'Applicant Manager'){
            this.canApprove = true;
            this.canReject = true;
          }else if(step == 'PM'){
            this.canApprove = true;
            this.canReject = true;
            this.canForward = true;
          }else if(step == 'Signer'){
            this.canApprove = true;
            this.canReject = true;
            this.canForward = true;
          }
        }
      }else{
        this.onlyView = true;
        apiHasEcrecnAuth({ headers: authHeader(), condition:this.form.id}).then((response) => { 
          if(response.status== 200 && response.data != null && response.data != ''&& response.data===true){  
            this.disabledEcrEcn = false;
          }
        }).catch((err) => {
          console.log(err);
        });

        
      }   
      //20220530 若結案後仍可上傳檔案
      if(this.form.status == 'Closed'){
        this.fileOnlyView = false;
      }else{
        this.fileOnlyView = this.onlyView;
      }
    },
    validatePm(){
      if(!CommonUtil.isNull(this.form.pm)){
        this.$refs.form.clearValidate('pm'); 
      }
    },
    validateApplyAccount(){   
      if(!CommonUtil.isNull(this.form.applyAccount)){
        this.$refs.form.clearValidate('applyAccount');
      }
    },
    saveSubmitCheck(){
      let pass = true;
      this.validatePm();
      this.validateApplyAccount();
      if(CommonUtil.isNull(this.form.applyAccount) || CommonUtil.isNull(this.form.reason)|| CommonUtil.isNull(this.form.target) || CommonUtil.isNull(this.form.pm)){
        this.$message.warning({showClose: true,message: this.$i18n.t('msg.incompleteInfo'), duration: 2000});
        pass = false;
      }
      if(pass){     
        let modelNameOther = this.form.modelNameArr.filter(function(item) {  
          return item == 'Other'
        });

        if(this.form.reason == this.reasonOpts[0] && CommonUtil.isNull(this.form.custSapCode)){
          pass = false;
          this.$message.warning({showClose: true,message: this.$i18n.t('msg.YRequiredWhenReasonX').replace('{field}',this.$i18n.t('field.customerNo')).replace('{reason}',this.reasonOpts[0]), duration: 2000});
        }else if(this.form.reason == this.reasonOpts[1] && CommonUtil.isNull(this.form.feedbackNo)){
          pass = false;
          this.$message.warning({showClose: true,message: this.$i18n.t('msg.YRequiredWhenReasonX').replace('{field}',this.$i18n.t('field.feedbackNo')).replace('{reason}',this.reasonOpts[1]), duration: 2000});
        }else if(this.form.reason == this.reasonOpts[2] && CommonUtil.isNull(this.form.description)){
          pass = false;
          this.$message.warning({showClose: true,message: this.$i18n.t('msg.YRequiredWhenReasonX').replace('{field}',this.$i18n.t('field.description')).replace('{reason}',this.reasonOpts[2]), duration: 2000});
        
        }else if(this.form.targetType == this.targetType[0] && this.form.modelNameArr.length == 0){
            pass = false;
            this.$message.warning({showClose: true,message: this.$i18n.t('msg.modelNameisRequiredWhenTargetCondition'), duration: 2000});        
        }


        if(pass){
          if(this.form.target == 'Other' && CommonUtil.isNull(this.form.targetOther)){
            pass = false;
            this.$message.warning({showClose: true,message: this.$i18n.t('field.systemNameandTypeHint'), duration: 2000});

          }else if(modelNameOther.length > 0  && CommonUtil.isNull(this.form.modelNameOther)){
            pass = false;
            this.$message.warning({showClose: true,message: this.$i18n.t('field.systemNameandTypeHint'), duration: 2000});

          }
        }        
      }
      
      if(pass){
        var endorserArr = this.$refs.endorsers.selectValue;
        if(endorserArr.length>0){
          this.form.endorser = '';//從元件再次重新set值
          endorserArr.forEach((item, index) => {   
            this.form.endorser += item+';';
          });
        }
        this.form.applyDate = Date.parse(this.form.applyDateStr);
        var modelNameArr = this.form.modelNameArr;
     
        if(modelNameArr.length>0){
          this.form.modelName = '';
          modelNameArr.forEach((item, index) => {   
            this.form.modelName += item+';';
          });
        }
      }
      return pass;
    },
    save(){      
      this.$refs['form'].validate((valid) => {      
        if(this.saveSubmitCheck()){
          apiSaveCrDoc({ headers: authHeader(), crDoc: this.form, signAction: this.signForm.signAction, signComment: this.signForm.signComment}).then((response) => {  
            this.dialogVisible = false;       
            if(response.status== 200 && response.data != null && response.data != ''){    
      
              this.form = response.data.crDoc;     
              this.saveSuccess = true;      
              this.$refs.fileList.docId = this.form.id;  //TODO這行會出錯
              this.$refs.fileList.save();               
              //需等到file都存檔完後才完成save,詳syncFileSave
            }else{
              this.loading = false;
              this.saveSuccess = false;        
            }
          }).catch((err) => {  console.log(err);  });
        }
      });
    },
    submit(){
      this.signForm.signAction = 'Submit';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    docDelete(){
      this.signForm.signAction = 'Cancelled';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    forward(){
      this.signForm.signAction = 'Forward';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    approve(){
      this.signForm.signAction = 'Approve';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    reject(){
      this.signForm.signAction = 'Reject';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    sendApprove(){
      this.signForm.signAction;
      this.signForm.signComment;
      this.signForm.forwardEmp;
      if( this.signForm.signAction=='Reject' && CommonUtil.isNull(this.signForm.signComment) ){
        return this.$message({ type: "error", message: this.$i18n.t('msg.commentRequiredWhenSignActionRejected'), duration: 1000}); 

      } else if( this.signForm.signAction=='Cancelled'  && CommonUtil.isNull(this.signForm.signComment) ){
        return this.$message({ type: "error", message: this.$i18n.t('msg.commentRequiredWhenSignActionDocDelete'), duration: 1000}); 

      } else {
        if(this.signForm.signAction == 'Submit'){
          this.save();
        }else{    
          this.loading = true;     
          apiSendApproveCRDoc({ headers: authHeader(), crDoc: this.form,signAction: this.signForm.signAction, 
                              signComment: this.signForm.signComment, forwardEmp:this.signForm.forwardEmp}).then((response) => {   
            let lastHistory = this.historyTable.data.filter(function(item) {  
              return (item.endTime == null || item.endTime == ''  )
            });
            if(lastHistory!= null && lastHistory.length > 0 && lastHistory[0].taskName == 'Applicant'){
              this.saveSuccess = true;      
              this.$refs.fileList.docId = this.form.id;  //TODO這行會出錯
              this.$refs.fileList.save();
            }else{
              this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 900}); 
              this.dialogVisible = false;   
              setTimeout(( () => location.reload()), 1000);
            }
       
          }).catch((err) => {  console.log(err);  this.dialogVisible = false;});
        }
      }      
    },
    syncPm(empNo){
      this.form.pm = empNo;
    },
    syncpRequestEmp(empNo){
      this.pRequestEmp = empNo;
      let no = empNo.substring(empNo.indexOf('(')+1,empNo.length -1);
      apiFindEmpByEmpNo({ headers: authHeader(), condition: no}).then((response) => {         
        if(response.status== 200 && response.data != null && response.data != ''){    
          this.form.applyAccount = response.data.name+'('+response.data.empNo+')';
          this.form.applyDept = response.data.dept;
          this.form.applyExtNo = response.data.ext;
        }
      }).catch((err) => {  console.log(err);  });
    },
    syncForwardEmp(empNo){
      this.signForm.forwardEmp = empNo;
    },
    syncEndorser(empNo){

    },
    syncSelectCustomer(cust){
      this.form.custSapCode = cust;
    },
    syncSelectFeedback(feedback){
      this.form.feedbackNo = feedback;
      
    },
    saveEcr(){
      apiSaveEcrecn({ headers: authHeader(), crDoc: this.form}).then((response) => { 
        if(response.status== 200 && response.data != null && response.data != ''){  
          if(response.data==true){
            this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 900});     
          }else{
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    createCnc(){      
      apiCreateCNC({ headers: authHeader(), condition:this.form.id}).then((response) => { 
    
        if(response.status== 200 && response.data != null && response.data != '' ){  
          this.$message({ type: "success", message: this.$i18n.t('msg.createCNCSuccess')+' '+response.data , duration: 1200});    
          setTimeout(( () => location.reload()), 1300); 
        }else{
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }
      }).catch((err) => {
        this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});
        console.log(err);
      });
    },
    syncFileSave(status){  
      this.loading = false;
      if(this.$route.fullPath.indexOf('/createCR') != -1){
        if(this.saveSuccess == true && status == true){
          this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 900});        
          setTimeout(( () => location.reload()), 1000);
          this.$router.push("/createCR/" + this.form.id);
        }else{
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }
      }
    },
    handleClose(done) {
      this.$confirm(this.$i18n.t('msg.confirmtoClose'),{
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.dialogVisible = false;
        done();
      }).catch(_ => {});
    },
    targetChange(){
  
      if(this.form.target != null && this.form.target != ''){
        this.targetOriData.forEach((item, index) => {       
          if(item.name == this.form.target){
            this.form.targetType = item.type;
          }
        });
      } else {
        this.form.targetType = '';
      }
      
      
    }
  },
  
  
};
</script>
<style >
.el-select .el-select--small {
  width: 100%;
}

input {
  width: 100%;
}

.ecrStyle {
  background:#ff00000d;
  overflow: auto;
  font-size: 14px;

}


</style>


